var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState, useEffect } from "react";
import EntitlementPreferenceControl from "./EntitlementPreferenceControl";
import MessagePreferenceClient from "../MessagePreferenceClient";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
var client = new MessagePreferenceClient();
var AccountPreferenceForm = function () {
    var _a = useState(true), loading = _a[0], setLoading = _a[1];
    var _b = useState(null), data = _b[0], setData = _b[1];
    var _c = useState(null), error = _c[0], setError = _c[1];
    var _d = useState(false), preferenceHasChanged = _d[0], setPreferenceHasChanged = _d[1];
    useEffect(function () {
        setLoading(true);
        client
            .get()
            .then(function (response) {
            setData(response.data);
            setLoading(false);
        })
            .catch(function (error) {
            setError({ message: window.MessagePreferenceContext.errorMessages.preferenceGet });
            console.error(error);
            setLoading(false);
        });
    }, []);
    var handlePreferenceChange = function (entitlementIdToUpdate, updatedPreferences) {
        setData(function (prevData) {
            if (!prevData)
                return null;
            return __assign(__assign({}, prevData), { accountPreferences: prevData.accountPreferences.map(function (entitlementPreference) {
                    return entitlementPreference.id === entitlementIdToUpdate
                        ? __assign(__assign({}, entitlementPreference), { disabledPreferences: updatedPreferences }) : entitlementPreference;
                }) });
        });
        setPreferenceHasChanged(true);
    };
    useEffect(function () {
        if (!data || !preferenceHasChanged)
            return;
        var requestBody = {
            preferences: data.accountPreferences.map(function (_a) {
                var imageDataSlug = _a.imageDataSlug, rest = __rest(_a, ["imageDataSlug"]);
                return rest;
            }),
        };
        client
            .post(requestBody)
            .then(function (response) {
            console.log(response);
            toast.success(response.data.success);
        })
            .catch(function (error) {
            console.error(error);
            toast.error(window.MessagePreferenceContext.errorMessages.preferenceSave);
        });
        setPreferenceHasChanged(false);
    }, [data, preferenceHasChanged]);
    if (loading)
        return (React.createElement("div", { className: "loading-container" },
            React.createElement("i", { className: "fa fa-spinner fa-spin fa-3x", "aria-hidden": "true" }),
            React.createElement("span", { className: "loading-text" }, "Loading...")));
    if (error)
        return (React.createElement("div", { className: "loading-preferences-error" },
            React.createElement("p", { dangerouslySetInnerHTML: { __html: error.message } })));
    return (React.createElement("div", null,
        React.createElement(ToastContainer, { position: "bottom-center", autoClose: 5000, hideProgressBar: false, newestOnTop: false, closeOnClick: true, rtl: false, pauseOnFocusLoss: true, draggable: true, pauseOnHover: true, theme: "light" }),
        data &&
            data.accountPreferences.map(function (preference, index) { return (React.createElement(EntitlementPreferenceControl, { key: index, preference: preference, preferenceChoices: data.preferenceChoices, onPreferenceChange: handlePreferenceChange })); })));
};
export default AccountPreferenceForm;
